import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-service-mobile',
  templateUrl: './service-mobile.component.html',
  styleUrls: ['./service-mobile.component.css']
})
export class ServiceMobileComponent implements OnInit {

   //commentted and new code added by Digvijay on 18-06-2019
   constructor(private meta: Meta,private titleService: Title) {
    this.meta.addTag({ name: 'description', content: 'Mobile Application Development - We have a high level of expertise on mobile app development skills to build and deploy apps on any mobile platform. ' },true);
    this.meta.addTag({ name: 'author', content: 'ShreeMon' },true);
    this.meta.addTag({ name: 'keywords', content: 'android app development company,android application development,android programming,android software development,android app development services,android programming,  android app development company in nj,android app development,  android app maker,' },true);    
    this.titleService.setTitle('Mobile Application Development | Shreemon');
  }

  ngOnInit() {
  }

}
